// extracted by mini-css-extract-plugin
export var core = "slider-module--core--7nQrI";
export var wrapper = "slider-module--wrapper--q53LD";
export var arrow = "slider-module--arrow--TRoi1";
export var dots = "slider-module--dots--hQEJk";
export var active = "slider-module--active--qGGDp";